export default __webpack_public_path__ + "static/media/menu_report_icon.26e0bc58.svg";